<i18n>
{
  "fr": {
    "content": "Démarche du projet labos 1point5"
  },
  "en": {
    "content": "Labos 1point5 approach"
  }
}
</i18n>

<template>
  <div>
    <h1>Démarche du projet labos 1point5</h1>
    <div>
      <p style="text-align: justify">
        <span v-html="$t('content')" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApproachPage'
}
</script>
